/* eslint-disable import/no-unresolved */
import React, { useState } from "react";
import { TextArea } from "@raketa-cms/raketa-cms";

import Modal from "../../../admin/Modal/Modal";
import ModalContent from "./ModalContent";

export default ({ value, label, onChange }) => {
  const [newValue, setValue] = useState(value);
  const [isModalVisible, setModalVisibility] = useState(false);

  return (
    <div className="markdown-input">
      <div
        style={{
          display: "flex",
          gap: "0.5rem",
          alignItems: "flex-end",
        }}
      >
        <div
          style={{
            maxWidth: "300px",
            width: "100%",
          }}
        >
          <TextArea
            label={label}
            onChange={(value) => {
              onChange(value);
              setValue(value);
            }}
            value={newValue}
          />
        </div>

        <button
          style={{ marginBottom: "1em", outline: "none", border: "none" }}
          type="button"
          onClick={() => setModalVisibility(true)}
          className="dialog-anchor glyphicon glyphicon-question-sign"
        />
      </div>

      <Modal open={isModalVisible}>
        <div
          style={{
            padding: "20px",
          }}
        >
          <ModalContent />

          <button
            type="button"
            style={{
              padding: "5px 10px",
              marginBottom: "10px",
              marginTop: "10px",
            }}
            onClick={() => setModalVisibility(false)}
          >
            OK
          </button>
        </div>
      </Modal>
    </div>
  );
};
